import { type OfferV11 } from '@redteclab/api/clients/bully'

import { TENANT } from '../../../tenant'

import { offerAccessorIsOfferMirakl } from './offerAccessorIsOfferMirakl'

const TENANTS_TO_SHOW_LAST_THIRTY_DAYS_PRICE = new Set<TENANT>([
  TENANT.AT,
  TENANT.BE,
  TENANT.COM,
  TENANT.IT,
])

export const offerAccessorIsLastThirtyDaysPriceEnabled = (
  offer: OfferV11 | undefined,
  tenant: TENANT,
): boolean => {
  if (!offer) {
    return false
  }

  return (
    TENANTS_TO_SHOW_LAST_THIRTY_DAYS_PRICE.has(tenant) &&
    offerAccessorIsOfferMirakl(offer.offerType)
  )
}
